import React from "react";
import logger from "logger";

import AccountDetailsSection from "TaskHistory/Tasklet/SubTasklets/AccountDetailsSection.js";
import StatusSection from "TaskHistory/Tasklet/SubTasklets/StatusSection.js";
import ErrorLogsSection from "TaskHistory/Tasklet/SubTasklets/ErrorLogsSection.js";
import ActionsSection from "TaskHistory/Tasklet/SubTasklets/ActionsSection.js";
import TaskletCard from "./TaskletCard";
import CardContent from "@material-ui/core/CardContent";
import { getTroopNameFromId, getAbbreviatedNumber } from "Utils/Common";
import { StringValue } from "./StringValue";
import { StringMap } from "./StringMap";
import * as taskservice from "Utils/TaskService";

export default function(props) {
  const { task } = props;

  const scorelog = {};
  task.taskstatusdetail.scorelegend &&
    task.taskstatusdetail.scorelegend.forEach((element) => {
      scorelog[element.hitno] = element.score;
    });

  let scoreLegendLimited = [];
  if (task.taskstatusdetail.scorelegend) {
    scoreLegendLimited = task.taskstatusdetail.scorelegend.slice(Math.max(task.taskstatusdetail.scorelegend.length - 30, 0))
  }

  return (
    <TaskletCard title="Goblin Kill">
      <CardContent>
        <AccountDetailsSection
          task={task}
          showOwner={props.showOwner}
          showUser={props.showUser}
        />
        <StringValue
          label={"Hero"}
          value={
            task.taskstatusdetail.selectedhero
              ? task.taskstatusdetail.selectedhero.heroname
              : ""
          }
          valueParser={(v) => <>{v}</>}
        />
        <StringValue
          label={"Campaign"}
          value={task.taskstatusdetail.campaign}
          valueParser={(v) => <>{v}</>}
        />
        <StringValue
          label={"Map:"}
          value={
            task.taskstatusdetail.level
              ? task.taskstatusdetail.level.levelname
              : ""
          }
          valueParser={(v) => <>{v}</>}
        />
        <StringValue
          label={"Stamina To Use:"}
          value={task.taskstatusdetail.usestams}
          valueParser={(v) => <>{v}</>}
        />
        <StringValue
          label={"Run Speed(In secs):"}
          value={task.taskstatusdetail.speedinsecs}
          valueParser={(v) => <>{v}</>}
        />
        <StringMap
          label={"Troops to send"}
          valueMap={task.taskstatusdetail.troops}
          valueParser={(k, v) => (
            <>
              {getTroopNameFromId(k)}: {v}
            </>
          )}
        />
        <StatusSection task={task} />
        <StringValue
          label={"Total hits done:"}
          value={
            <>
              {task.taskstatusdetail.totalhitsdone}/
              {task.taskstatusdetail.noOfHits}
            </>
          }
          valueParser={(v) => <>{v}</>}
        />
        {true && (
          <div>
            <div
              className="infokey enlargeonhover"
              style={{ fontSize: "15px" }}
              onClick={(event) => {
                taskservice.showAllNotifications(scorelog);
              }}
            >
              Score Legend (Click to see all)
            </div>
            {scoreLegendLimited.map((item) => {
              return (
                <div className="infovalue" style={{ fontSize: "10px" }}>
                  {getAbbreviatedNumber(item.score)} ({item.score})
                </div>
              );
            })}
            <div className="infovalue" style={{ fontSize: "10px" }}>
              Total Score :
              {getAbbreviatedNumber(task.taskstatusdetail.totalscore)}
            </div>
          </div>
        )}
        <ErrorLogsSection task={task} />
      </CardContent>
      <ActionsSection task={task} />
    </TaskletCard>
  );
}
